import React, { useEffect, useState } from 'react';
import useLocalStorage from '../hooks/useLocalStorage';

const themes = [
    "light",
    "dark",
];

interface ThemeSelectorProps {
    asSelectInput?: boolean
};

const ThemeSelector: React.FC<ThemeSelectorProps> = ({ asSelectInput }) => {
    const [theme, setTheme] = useLocalStorage<string>('theme', 'dark');

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);

        // Create a custom event with theme detail
        const themeChangeEvent = new CustomEvent('daisyui-theme-change', {
            detail: { theme },
        });

        // Dispatch custom event when theme changes
        document.dispatchEvent(themeChangeEvent);
    }, [theme]);

    return (
        <div>
            {asSelectInput === true ? (
                <div>
                    <div className="form-control mb-2">
                        <label className="label">
                            <span className="label-text">Color Theme:</span>
                        </label>
                        <select
                            className="select dropdown-content select-bordered w-full"
                            value={theme}
                            onChange={(e) => setTheme(e.target.value)}
                        >
                            {themes.map((theme, index) => (
                                <option key={index} value={theme}>{theme}</option>
                            ))}
                        </select>
                    </div>
                </div>
            ) : (
                <div className="dropdown dropdown-end">
                    <label tabIndex={0} className="btn btn-ghost btn-circle">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <circle cx="12" cy="12" r="4" />
                            <path d="M12 2v2" />
                            <path d="M12 20v2" />
                            <path d="M4.93 4.93l1.41 1.41" />
                            <path d="M17.66 17.66l1.41 1.41" />
                            <path d="M2 12h2" />
                            <path d="M20 12h2" />
                            <path d="M6.34 17.66l-1.41 1.41" />
                            <path d="M19.07 4.93l-1.41 1.41" />
                        </svg >
                    </label >
                    <ul tabIndex={0} className="menu dropdown-content z-[1] p-2 shadow bg-base-100 rounded-box w-52 mt-4">
                        {themes.map((t) => (
                            <li key={t}>
                                <a
                                    className={theme === t ? 'active' : ''}
                                    onClick={() => setTheme(t)}
                                >
                                    {t}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div >
            )}
        </div>
    );
};


export default ThemeSelector;